import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import withModal from '../WithModal';
import Image from '../../ImageResizer/ImageResizer';
import nextArrow from '../../../shared/assets/icon-right-arrow.png';
import prevArrow from '../../../shared/assets/icon-left-arrow.png';
import svgInline from '../../SvgInline/SvgInline';
import closeIcon from '../../../shared/assets/icon-close.svg';

import './SlideshowModal.css';

export class SlideshowModalComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentImageIndex: 0,
    };

    this.nextImage = this.nextImage.bind(this);
    this.prevImage = this.prevImage.bind(this);
  }

  componentDidMount() {
    this.leftButton.focus();
  }

  nextImage(imgCount) {
    this.setState(prevState => {
      const { currentImageIndex } = prevState;
      const newImageIndex = (currentImageIndex + 1 >= imgCount) ? 0 : currentImageIndex + 1;
      return {
        ...prevState,
        currentImageIndex: newImageIndex,
      };
    });
  }

  prevImage(imgCount) {
    this.setState(prevState => {
      const { currentImageIndex } = prevState;
      const newImageIndex = (currentImageIndex - 1 < 0) ? imgCount - 1 : currentImageIndex - 1;
      return {
        ...prevState,
        currentImageIndex: newImageIndex,
      };
    });
  }

  render() {
    const adjustmentPercentage = 0.75;
    const { onModalClick, images, modalTitle } = this.props;
    const title = modalTitle || 'Photos';
    const { currentImageIndex } = this.state;
    const image = images[currentImageIndex];
    const adjImgWidth = Math.round(Math.max(
      (document.documentElement.clientWidth, window.innerWidth || 0) * adjustmentPercentage));
    const adjImgHeight = Math.round(Math.max(
      (document.documentElement.clientHeight, window.innerHeight || 0) * adjustmentPercentage));
    const imageDescription = (image && image.description) || '';
    const imageFilename = (image && image.filename.trim()) || '';
    const buttonVisibility = images.length === 1 ? 'hidden' : 'visible';
    return (
      <div className="slideshow-modal">
        <KeyboardEventHandler
          handleKeys={['left', 'right']}
          onKeyEvent={key => (key === 'left' ? this.prevImage(images.length) : this.nextImage(images.length))}
        >
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <div className="modal-header slideshow-modal-header">
              <h2 className="modal-title slideshow-modal-title">{title}</h2>
              <div className="slideshow-modal-status">
                {currentImageIndex + 1} of {images.length}
              </div>
              <a tabIndex="0" onClick={onModalClick}>
                <div className="modal-close">
                  {svgInline(closeIcon)}
                </div>
              </a>
            </div>
          </ViewerPrimaryColorUserStyle>
          <div
            className="slideshow-modal-image-wrapper"
          >
            <div className="slideshow-modal-image">
              <button
                style={{ visibility: buttonVisibility }}
                ref={btn => { this.leftButton = btn; }}
                onClick={() => this.prevImage(images.length)}
                className="slideshow-modal-nav-button prev"
              >
                <img src={prevArrow} alt="" />
              </button>
              {image &&
                <Image
                  height={adjImgHeight}
                  width={adjImgWidth}
                  image={image}
                />
              }
              <button
                style={{ visibility: buttonVisibility }}
                onClick={() => this.nextImage(images.length)}
                className="slideshow-modal-nav-button next"
              >
                <img src={nextArrow} alt="" />
              </button>
            </div>
            <div className="slideshow-modal-image-info">
              <div className="slideshow-image-details">
                {images.length > 1 &&
                  <p className="slideshow-image-instructions">Click on left or right side of image or use arrow keys to navigate images</p>
                }
                <p className="slideshow-image-description">{imageDescription}</p>
              </div>
              <div className="slideshow-image-actions">
                <a href={imageFilename} download target="_blank" rel="noopener noreferrer">[download]</a>
                <a tabIndex="0" onClick={onModalClick}>[close]</a>
              </div>
            </div>
          </div>
        </KeyboardEventHandler>
      </div>
    );
  }
}

SlideshowModalComponent.propTypes = {
  onModalClick: PropTypes.func.isRequired,
  modalTitle: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    sequence: PropTypes.number,
    filename: PropTypes.string,
    description: PropTypes.string,
  })),
};


export default withModal(SlideshowModalComponent, 'slideshow');



// WEBPACK FOOTER //
// ./src/components/Modal/SlideshowModal/SlideshowModal.js